module.exports = __webpack_public_path__ + "6447b6e8325cf956d5c7f87e63beb916.png";